// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"349":"46028b56","529":"657f060a","825":"4fd67e8c","895":"066d11fc"}[chunkId] + ".chunk.js";
};